import moment from 'moment';
import { startScriptFlow } from 'script-flow';
import experimentScriptFlowDefinition from 'experiment/scriptFlowDefinition';

// Action Types
export const typePrefix = 'vra/experiment/';
export const actions = [
  'SET_EXPERIMENT_APPLICATION',
  'SET_EXPERIMENT_APPLICATION_DATE',
  'SET_EXPERIMENT_APPLICATION_RATE',
  'SET_EXPERIMENT_APPLICATION_TYPE',
  'SET_EXPERIMENT_SCRIPT_PARAMS',
  'SET_FIELD_SEASONS',
  'SET_SHOW_CONFIRM_MODAL',
  'SET_PRESCRIPTION_STATUS',
  'SET_ERROR',

  // analytics
  'CANCEL_EXPERIMENT_FLOW',
  'NAVIGATE_EXPERIMENT_FLOW',
  'FINISH_SCRIPT'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});
export const nav = [
  'BACK',
  'FORWARD'
].reduce((result, key) => { result[key] = key; return result; }, {});

// Reducer
export default function reducer(
  state = {
    application: {
      date: moment(new Date()).toISOString(),
      selectedProduct: {}
    },
    error: undefined,
    fieldSeasons: undefined,
    prescriptionStatus: undefined,
    showConfirmModal: false,
    step: 1
  },
  action = { payload: {}, type: undefined }
) {
  switch (action.type) {
    case actions.SET_EXPERIMENT_APPLICATION:
      return {
        ...state,
        application: {
          ...state.application,
          selectedProduct: {
            id: action.payload.id,
            name: action.payload.name
          }
        }
      };
    case actions.SET_EXPERIMENT_APPLICATION_DATE:
      return {
        ...state,
        application: {
          ...state.application,
          date: action.payload.date
        }
      };
    case actions.SET_EXPERIMENT_APPLICATION_RATE:
      return {
        ...state,
        application: {
          ...state.application,
          rate: action.payload.applicationRate
        }
      };
    case actions.SET_EXPERIMENT_APPLICATION_TYPE:
      return {
        ...state,
        application: {
          ...state.application,
          type: action.payload.applicationType
        }
      };
    case actions.SET_EXPERIMENT_SCRIPT_PARAMS:
      return {
        ...state,
        params: { ...state.params, ...action.payload.newParams }
      };
    case actions.SET_SHOW_CONFIRM_MODAL:
      return {
        ...state,
        showConfirmModal: action.payload.showConfirmModal
      };
    case actions.SET_PRESCRIPTION_STATUS:
      return {
        ...state,
        prescriptionStatus: action.payload.prescriptionStatus
      };
    case actions.SET_ERROR:
      return {
        ...state,
        error: action.payload.error
      };
    default:
      return state;
  }
}

export const setApplicationTypeForExperiment = (applicationType) => ({
  type: actions.SET_EXPERIMENT_APPLICATION_TYPE,
  payload: { applicationType }
});

export const setSelectedProductForExperiment = (selectedProduct) => ({
  type: actions.SET_EXPERIMENT_APPLICATION,
  payload: { name: selectedProduct.name, id: selectedProduct.id }
});

export const updateExperimentApplicationDate = (date) => ({
  type: actions.SET_EXPERIMENT_APPLICATION_DATE,
  payload: { date }
});

export const updateProductApplicationRate = (applicationRate) => ({
  type: actions.SET_EXPERIMENT_APPLICATION_RATE,
  payload: { applicationRate }
});

export const startExperimentTrialFlow = () => startScriptFlow({ definition: experimentScriptFlowDefinition });

export const setExperimentScriptParams = (newParams) => {
  return {
    type: actions.SET_EXPERIMENT_SCRIPT_PARAMS,
    payload: { newParams }
  };
};

export const setShowConfirmModal = (showConfirmModal) => {
  return {
    type: actions.SET_SHOW_CONFIRM_MODAL,
    payload: { showConfirmModal }
  };
};

export const setPrescriptionStatus = (prescriptionStatus) => {
  return {
    type: actions.SET_PRESCRIPTION_STATUS,
    payload: { prescriptionStatus }
  };
};

export const setError = (error) => {
  return {
    type: actions.SET_ERROR,
    payload: { error }
  };
};